module.exports = __webpack_public_path__ + "static/images/index-pendant.25688c2.png";